import { Directive, ElementRef, Input, OnChanges } from '@angular/core';
import { AlertType } from '@authority-labs/enums';

@Directive({
  selector: '[authorityLabsAlertColor]'
})
export class AlertColorDirective implements OnChanges {
  @Input('authorityLabsAlertColor') alertType: AlertType = AlertType.Info;

  constructor(private el: ElementRef) {}

  ngOnChanges(): void {
    switch (this.alertType) {
      case AlertType.Danger:
        this.el.nativeElement.style.color = 'red';
        break;
      case AlertType.Warning:
        this.el.nativeElement.style.color = 'orange';
        break;
      default:
        this.el.nativeElement.style.color = 'inherit';
        break;
    }
  }
}
